import React, { useEffect, useRef, useState } from "react";
import "./AdminBlogs.css";
import { useNavigate } from "react-router-dom";
import { GetAdminsBlogs } from "../../api/blogApis/blogApi";
import { CommonStatus } from "../../app/Enums/StatusEnums";
import { RoleId } from "../../app/Enums/RoleId";
import { DeleteBlog } from "../../api/blogApis/blogApi";
import { toast } from "react-toastify";
import { blogVisibilityStatus } from "../../app/Enums/StatusEnums";
import { changeBlogVisisbility } from "../../api/blogApis/blogApi";
import { routePath } from "../../app/routes/routepath";
import LoadingSpinner from "../../app/components/Loader/LoadingSpinner";
import viewSvg from "../../assets/icons/view.svg";
import binSvg from "../../assets/icons/bin.svg";
import editSvg from "../../assets/icons/edit.svg";
import addSvg from "../../assets/icons/add.svg";
import DeleteModal from "../../app/components/FeedbackModal/DeleteModal/DeleteModal";
import {
  Ban,
  CheckCircle,
  Eye,
  Lock,
  SquarePen,
  ToggleLeft,
  ToggleRight,
  Trash2,
  Unlock,
} from "lucide-react";
const AdminBlog = () => {
  const navigate = useNavigate();

  const [response, setResponse] = useState([]);
  const [adminBlog, setAdminBlogs] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const [isAdmin, setIsAdmin] = useState(true);
  const [onfilter, setOnFilter] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [isEnabled, setIsEnabled] = useState(true);
  const [visibilityOption, setVisibilityAction] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  // const [selectedOption , setSelectedOption] = useState("All");
  const [deleteReqData, setDeleteReqData] = useState({
    blogId: 0,
  });
  const [visibilityReqData, setVisibilityReqData] = useState({
    blogId: null,
    visibiblityStatus: null,
  });
  // const [isAdmin, setIsAdmin] = useState(true);
  // const [onfilter, setOnFilter] = useState(true);

  const [selectedOption, setSelectedOption] = useState("");
  const [reqData, setReqData] = useState({
    authorId: 0,
    roleId: 0,
    statusId: null,
    pageNo: 1,
    pageSize: 10,
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");
  const tableRef = useRef(null);
  const authorId = Number(localStorage.getItem("UserId"));
  const roleId = Number(localStorage.getItem("RoleId"));
  useEffect(() => {
    let setStatusAsPerRole = 0;

    if (roleId === RoleId.SuperAdmin) {
      setStatusAsPerRole = null; // All
    } else if (roleId === RoleId.Admin) {
      setStatusAsPerRole = CommonStatus.Approved;
      setOnFilter(true);
      setVisibilityAction(true);
    }

    if (roleId == RoleId.Admin) {
      setIsAdmin(true);
    } else if (roleId == RoleId.SuperAdmin) {
      setIsAdmin(false);
    }

    setReqData((prev) => ({
      ...prev,
      authorId: authorId,
      roleId: roleId,
      statusId: setStatusAsPerRole,
    }));
  }, []);

  useEffect(() => {
    if (reqData.authorId && reqData.roleId) {
      GetBlogs();
    }
  }, [reqData.authorId, reqData.roleId, reqData]);

  // When currentPage or pageSize changes, update reqData
  useEffect(() => {
    setReqData((prev) => ({
      ...prev,
      pageNo: currentPage,
      pageSize: pageSize,
    }));
  }, [currentPage, pageSize]);

  const GetBlogs = async () => {
    try {
      const result = await GetAdminsBlogs(reqData);
      if (result) {
        setResponse(result);
        setAdminBlogs(result.result_value);
        console.log(result);
        setTotalCount(result.totalRows);
        setIsLoading(false);
      }
    } catch (err) {
      console.error("Error fetching blogs", err);
    }
  };

  const navigateDashboard = () => {
    navigate(routePath.dashboard);
  };

  const navigateCreateBlog = () => {
    navigate(routePath.AddBlog);
  };

  const handleChange = (e) => {
    var selectedValue = e.target.value;
    setSelectedOption(selectedValue);

    // if (selectedValue == "All") {
    //   setOnFilter(false);
    //   setVisibilityAction(true);
    //   setReqData((prev) => ({
    //     ...prev,
    //     statusId: null,
    //   }));
    // }
    if (selectedValue == "Approved") {
      setOnFilter(true);
      setVisibilityAction(true);
      setReqData((prev) => ({
        ...prev,
        statusId: CommonStatus.Approved,
      }));
    } else if (selectedValue == "Draft") {
      setOnFilter(true);
      setVisibilityAction(false);
      setReqData((prev) => ({
        ...prev,
        statusId: CommonStatus.Archived,
      }));
    }
  };

  const handleView = (blogId) => {
    navigate(routePath.ViewAdminBlog, {
      state: { blogId, returnPath: routePath.adminBlog },
    });
  };

  const handleEdit = (blogId) => {
    navigate(routePath.editBlog, { state: { blogId } });
  };

  const handleDelete = (DeleteblogId) => {
    setDeleteReqData({
      blogId: DeleteblogId,
    });
    setDeleteModal(true);
  };
  const handleConfirmDelete = () => {
    setDeleteModal(false);
    FinalDeleteBlog();
  };
  const FinalDeleteBlog = async () => {
    var response = await DeleteBlog(deleteReqData);
    if (response.result == 1) {
      GetBlogs();
      toast.success("Deleted Successfully");
    } else {
      toast.error("could not delete");
    }
  };

  const handleToggle = async (selectedBlogId, currentStatus) => {
    const newStatus =
      currentStatus == true
        ? parseInt(blogVisibilityStatus.disable)
        : parseInt(blogVisibilityStatus.enable);
    setVisibilityReqData({
      blogId: selectedBlogId,
      visibiblityStatus: newStatus,
    });
  };
  useEffect(() => {
    if (
      visibilityReqData.blogId != null &&
      visibilityReqData.visibiblityStatus != null
    ) {
      ChangeBlogVisisbilityFunction();
    }
  }, [visibilityReqData]);

  const ChangeBlogVisisbilityFunction = async () => {
    console.log("visibilityReqData", visibilityReqData);
    debugger;
    var result = await changeBlogVisisbility(visibilityReqData);
    if (result.result == 1) {
      GetBlogs();
      if (visibilityReqData.visibiblityStatus == blogVisibilityStatus.enable) {
        toast.success("blog enabled successfully");
      } else {
        toast.success("blog disabled successfully");
      }
      // toast.success("blog visibility changed successfully");
    } else {
      toast.error("something went wrong try again");
    }
  };

  // const handleChange = (e) => {
  //   var selectedValue = e.target.value;
  //   setSelectedOption(selectedValue);

  //   if (selectedValue == "All") {
  //     setOnFilter(true);
  //     setReqData((prev) => ({
  //       ...prev,
  //       statusId: null,
  //     }));
  //   } else if (selectedValue == "Posted") {
  //     setOnFilter(false);
  //     setReqData((prev) => ({
  //       ...prev,
  //       statusId: CommonStatus.Approved,
  //     }));
  //   } else if (selectedValue == "Archived") {
  //     setOnFilter(false);
  //     setReqData((prev) => ({
  //       ...prev,
  //       statusId: CommonStatus.Archived,
  //     }));
  //   }
  // };

  const openModal = (description) => {
    setSelectedDescription(description);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedDescription("");
  };

  useEffect(() => {
    tableRef.current?.scrollTo({ top: 0, behavior: "smooth" });
  }, [pageSize, currentPage]);

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <div className="main-out-wraper">
          <div className="role-box">
            <h2 className={roleId === RoleId.Admin ? "" : "mb-0"}>
              Admin Blog
            </h2>
            {/* {roleId === RoleId.SuperAdmin && (
              <span>All Admins Approved Blogs shows here!</span>
            )} */}
            <div className="search-filter-section">
              {roleId === RoleId.Admin && (
                <div className="form-wraper">
                  <label>Select Option</label>
                  <select value={selectedOption} onChange={handleChange}>
                    {/* <option>Select Option</option> */}
                    {/* <option value="All">All</option> */}
                    <option value="Approved">Approved</option>
                    <option value="Draft">Draft</option>
                  </select>
                </div>
              )}

              <div>
                {roleId === RoleId.Admin && (
                  <button className="primary_btn" onClick={navigateCreateBlog}>
                    <img src={addSvg} alt="Add" />
                    Add Blogs
                  </button>
                )}
              </div>
              <div></div>
            </div>
          </div>

          <div className="main_widget">
            <div className="main_widget_body">
              <div className="table-responsive" ref={tableRef}>
                <table>
                  <thead>
                    <tr>
                      <th className="sn_th">S. No</th>
                      <th className="name_th">Title</th>
                      <th className="cover_th">Image</th>
                      <th className="des_th">Summary</th>

                      {!onfilter && <th className="auth_th">authorName</th>}

                      {/* {!onfilter &&
                    (isAdmin ? <th>Status</th> : <th>authorName</th>)} */}

                      <th className="action_th">Action</th>
                      {(reqData.statusId == CommonStatus.Approved &&
                        roleId == RoleId.Admin) ||
                      roleId == RoleId.SuperAdmin ? (
                        //  ||
                        //   Value.StatusId == 0
                        <th className="action_th">Status</th>
                      ) : null}
                    </tr>
                  </thead>
                  <tbody>
                    {adminBlog?.map((item, index) => (
                      <tr key={index}>
                        <td>
                          {(reqData?.pageNo - 1) * reqData?.pageSize +
                            index +
                            1}
                        </td>
                        <td>{item.blogTitle}</td>
                        <td>
                          <div>
                            <img
                              className="CoverImage"
                              src={item.blogCoverImage}
                            />
                          </div>
                        </td>
                        <td>
                          {/* {item.blogDescription} */}
                          {item.blogDescription.length > 80 ? (
                            <>
                              {item.blogDescription.slice(0, 80)}...
                              <span
                                className="see-more"
                                onClick={() => openModal(item.blogDescription)}
                              >
                                {" "}
                                See more
                              </span>
                            </>
                          ) : (
                            item.blogDescription
                          )}
                        </td>

                        {!onfilter && <td>{item.authorName || "Unknown"}</td>}

                        <td className="">
                          <div className="d-flex align-items-center justify-content-center gap_10">
                            <div
                              className="tooltip-wrapper"
                              style={{ "--bg-color": "#002954" }}
                              onClick={() => handleView(item.blogId)}
                            >
                              <Eye className="icon icon-view" />
                              <span className="tooltip-text">
                                View Admin Blog
                              </span>
                            </div>

                            {onfilter && (
                              <div
                                className="tooltip-wrapper"
                                style={{ "--bg-color": "#F59E0B" }}
                                onClick={() => handleEdit(item.blogId)}
                              >
                                <SquarePen className="icon icon-btn" />
                                <span className="tooltip-text">
                                  Edit Admin Blog
                                </span>
                              </div>
                            )}

                            {isAdmin
                              ? onfilter && (
                                  <div
                                    className="tooltip-wrapper"
                                    style={{ "--bg-color": "#dc2626" }}
                                    onClick={() => handleDelete(item.blogId)}
                                  >
                                    <Trash2 className="icon icon-deactivated" />
                                    <span className="tooltip-text">
                                      Delete Admin Blog
                                    </span>
                                  </div>
                                )
                              : null}
                          </div>
                        </td>

                        {reqData.statusId === null &&
                          (roleId === RoleId.Admin ||
                            roleId === RoleId.SuperAdmin) && (
                            <td>
                              {item.isActive === true ? (
                                <div
                                  id="EnableVisibility"
                                  className="tooltip-wrapper"
                                  style={{ "--bg-color": "#16a34a" }}
                                >
                                  <CheckCircle className="icon icon-active" />
                                  <span className="tooltip-text">Active</span>
                                </div>
                              ) : (
                                <div
                                  id="DisableVisibility"
                                  className="tooltip-wrapper"
                                  style={{ "--bg-color": "#dc2626" }}
                                >
                                  <Ban className="icon icon-inactive" />
                                  <span className="tooltip-text">Inactive</span>
                                </div>
                              )}
                            </td>
                          )}

                        {reqData.statusId === CommonStatus.Approved &&
                          roleId === RoleId.Admin && (
                            <td>
                              {item.isActive === true ? (
                                // <button
                                //   className="label_btn disable_btn"
                                //   onClick={() =>
                                //     handleToggle(item.blogId, item.isActive)
                                //   }
                                // >
                                //   Disable
                                // </button>
                                <div
                                  className="tooltip-wrapper"
                                  style={{ "--bg-color": "#dc2626" }}
                                  onClick={() =>
                                    handleToggle(item.blogId, item.isActive)
                                  }
                                >
                                  <Unlock className="icon icon-deactivated" />
                                  <span className="tooltip-text">Disable</span>
                                </div>
                              ) : (
                                // <button
                                //   className="label_btn enable_btn"
                                //   onClick={() =>
                                //     handleToggle(item.blogId, item.isActive)
                                //   }
                                // >
                                //   Enable
                                // </button>
                                <div
                                  className="tooltip-wrapper"
                                  style={{ "--bg-color": "#22c55e" }}
                                  onClick={() =>
                                    handleToggle(item.blogId, item.isActive)
                                  }
                                >
                                  <Lock className="icon icon-approved" />
                                  <span className="tooltip-text">Enable</span>
                                </div>
                              )}
                            </td>
                          )}
                        {/* {((!isAdmin && selectedOption !== "Archived") ||
                          (isAdmin && selectedOption === "Posted")) && (
                            <td>
                              {!isAdmin ? (
                                <label className="switch">
                                  <input
                                    type="checkbox"
                                    checked={item.isActive === true}
                                    onChange={() => {
                                      handleToggle(item.blogId, item.isActive);
                                    }}
                                  />
                                  <span className="slider"></span>
                                </label>
                              ) : (
                                <label className="switch">
                                  <input
                                    type="checkbox"
                                    checked={item.isActive === true}
                                    disabled
                                  />
                                  <span className="slider"></span>
                                </label>
                              )}
                            </td>
                          )} */}
                      </tr>
                    ))}

                    {response.length === 0 && (
                      <tr>
                        <td colSpan="8" style={{ textAlign: "center" }}>
                          No Blogs found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* pagination  */}
          <div className="pagination_wraper">
            <div className="d-flex align-items-center">
              <div>
                <label className="page-size">Rows per page: </label>
              </div>
              <div className="PageSizeChageDropdown">
                <select
                  value={pageSize}
                  onChange={(e) => {
                    setPageSize(parseInt(e.target.value));
                    setCurrentPage(1); // reset to page 1
                  }}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </select>
              </div>
            </div>
            {/* <select
          value={pageSize}
          onChange={(e) => {
            setPageSize(parseInt(e.target.value));
            setCurrentPage(1); // reset to page 1
          }}
        >
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
        </select> */}

            <ul className="page">
              <li
                className="page__btn"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                <img
                  src={require("../../assets/images/arrow.png")}
                  className="material-icons left_arrow"
                  alt="Arrow"
                />
              </li>

              {/* Page Numbers */}
              {Array.from(
                { length: Math.ceil(totalCount / pageSize) },
                (_, i) => (
                  <li
                    key={i + 1}
                    onClick={() => setCurrentPage(i + 1)}
                    className={`page__numbers ${
                      currentPage === i + 1 ? "active" : ""
                    }`}
                  >
                    {i + 1}
                  </li>
                ),
              )}

              <li
                className="page__btn"
                onClick={() =>
                  setCurrentPage((prev) =>
                    prev < Math.ceil(totalCount / pageSize) ? prev + 1 : prev,
                  )
                }
                disabled={currentPage >= Math.ceil(totalCount / pageSize)}
              >
                <img
                  src={require("../../assets/images/arrow.png")}
                  className="material-icons"
                  alt="Arrow"
                />
              </li>
            </ul>
          </div>
        </div>
      )}
      {/* delete modal */}
      {/* {deleteModal && (
        <div className="modal-overlay">
          <div className="modal delete-modal">
            <h3>Are you sure you want to delete this blog?</h3>
            <div className="modal-buttons">
              <button className="confirm-btn" onClick={handleConfirmDelete}>
                Yes, Delete
              </button>
              <button
                className="cancel-btn"
                onClick={() => setDeleteModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
        <div className="modal-overlay">
          <div className="delete-modal">
            <h2>Delete Blog</h2>
            <p>Are you sure you want to delete this blog?</p>
            <div className="modal-actions">
              <button
                className="delete_approve_btn"
                onClick={handleConfirmDelete}
              >
                Yes, I’m Sure
              </button>
              <button
                className="delete_reject_btn"
                onClick={() => setDeleteModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )} */}

      <DeleteModal
        isOpen={deleteModal}
        onConfirm={() => {
          handleConfirmDelete();
        }}
        onCancel={() => {
          setDeleteModal(false);
        }}
        title="Delete Blog"
        message={`Are you sure you want to delete this blog?`}
      />

      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="delete-modal" onClick={(e) => e.stopPropagation()}>
            <h2>Summary</h2>
            <p>{selectedDescription}</p>
            <div className="d-flex justify-content-center">
              <button className="primary_btn" onClick={closeModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminBlog;
